import React, { useState } from 'react';
import {Button, Modal, Spinner} from "react-bootstrap";

interface ConfirmAgreementOfferRejectModal {
    confirm: () => void
    cancel: () => void
}

export function ConfirmAgreementOfferRejectModal(props: ConfirmAgreementOfferRejectModal) {

    const [loading, setLoading] = useState(false);

    const onConfirm = () => {
        setLoading(true);
        props.confirm();
    }

    return (
        <>
            <Modal
                show={true}
                size={"lg"}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                onHide={props.cancel}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Pakkumusest keeldumine
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="">
                        Kas oled kindel, et soovid teile tehtud pakkumusest keelduda?
                    </div>
                </Modal.Body>
                <Modal.Footer className="d-flex flex-row align-items-end justify-content-around flex-wrap mb-1">
                    <Button variant="outline-dark"
                            onClick={props.cancel}
                            disabled={loading}
                            type="button"
                            className={"d-flex align-items-center"}>
                        <span className='px-2'>Tühista</span>
                    </Button>
                    <Button 
                        variant="primary"
                        onClick={onConfirm}
                        disabled={loading}
                        type="button"
                        className="d-flex align-items-center"
                    >
                        <span className='px-2'>{ loading ? <Spinner animation='border' className='mr-2' /> : false }Keeldu pakkumusest</span>
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
